import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Typography(theme: Theme) {
  return {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          // The app view heading is an <h1>; the variant only carries the styling.
          pageTitle: 'h1',
          // The data variants carry no semantics — they are inline values.
          data: 'span',
          dataMedium: 'span',
          dataDisplay: 'span',
        },
      },
      styleOverrides: {
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
        // Headings occasionally carry a number (a survey name with a year, a
        // count in a section title). They stay in DM Sans, but go tabular so
        // they do not jitter when the value changes under a filter.
        h1: { fontVariantNumeric: 'tabular-nums' },
        h2: { fontVariantNumeric: 'tabular-nums' },
        h3: { fontVariantNumeric: 'tabular-nums' },
        h4: { fontVariantNumeric: 'tabular-nums' },
        subtitle2: { fontVariantNumeric: 'tabular-nums' },
        // Metrics and counts read as data, and stay aligned while they update.
        overline: {
          fontVariantNumeric: 'tabular-nums',
        },
        caption: {
          fontVariantNumeric: 'tabular-nums',
        },
      },
    },
  }
}
